@if (redDot$ | async) {
  <!-- eslint-disable-next-line @angular-eslint/template/interactive-supports-focus -->
  <div
    aria-label="redDot"
    style="width: 20px; height: 20px"
    class="redDot"
    (click)="onClick()"
    role="button"
  ></div>
}
